/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_HumInputs */

const fr_fancy_vast_otter_hum = /** @type {(inputs: Fancy_Vast_Otter_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jour`)
};

/**

* @param {Fancy_Vast_Otter_HumInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_hum = /** @type {((inputs?: Fancy_Vast_Otter_HumInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_HumInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_hum(inputs)
});